import React from 'react';
import { User } from 'api/models';
import { Configuration } from 'api/timesheets/configuration/configuration';
import { ToastDescription, toastService } from 'components/molecules/toast';
import { Translate, TranslationKey } from 'hooks/use-translation';
import { fullName } from 'utils/full-name';
import { TimesheetTableTimeEntry } from './types';

type ActionNames = 'update' | 'add' | 'delete';

interface MoreInfo {
  task: string;
  day: string;
}

export const getTimesheetHandleError =
  (user: User, translate: Translate, refreshData?: () => void) =>
  (error: any, actionName: ActionNames, moreInfo?: MoreInfo): void => {
    const {
      response: {
        data: { errors },
      },
    } = error;
    const alreadyApproved = errors?.find(({ reason }) =>
      reason?.startsWith(
        `Can't ${actionName} entry as the timesheet is approved`,
      ),
    );

    if (alreadyApproved) {
      toastService({
        title: translate(
          'timesheets.toast.titles.entry_action_failed_due_to_approval' as TranslationKey,
        ),
        message: (
          <ToastDescription
            message={translate(
              'timesheets.toast.messages.entry_action_failed_due_to_approval' as TranslationKey,
              { userName: fullName(user) },
            )}
            onClick={refreshData}
            buttonText={translate('refresh' as TranslationKey)}
          />
        ),
      }).error();
    }

    const exceeds24hrs = errors?.find(({ reason }) =>
      reason.startsWith('Invalid minutes specified'),
    );

    if (exceeds24hrs) {
      const message = moreInfo
        ? 'timesheets.toast.messages.entry_action_failed_due_to_exceeds_hours.more_info'
        : 'timesheets.toast.messages.entry_action_failed_due_to_exceeds_hours';

      toastService({
        title: translate(
          'timesheets.toast.titles.entry_action_failed_due_to_approval' as TranslationKey,
        ),
        message: (
          <ToastDescription
            message={translate(message as TranslationKey, {
              userName: fullName(user),
              ...moreInfo,
              b: (chunks) => <b>{chunks}</b>,
            })}
            onClick={refreshData}
            buttonText={translate('refresh' as TranslationKey)}
          />
        ),
      }).error();
    }
  };

export const isTimeEntrySubmittable = (
  entry: TimesheetTableTimeEntry,
  config: Configuration | null | undefined,
) => {
  if (!config?.configMeta.categoryMandatory) {
    return true;
  }
  if (!entry.minutes) {
    return true;
  }
  if (!entry.category?.categoryId) {
    return false;
  }

  return true;
};
